import { styled } from '@linaria/react'
import { ActionButtonSC } from 'atoms/ActionButton'
import { IconSC } from 'atoms/Icon'
import { Dropdown, DropdownBody } from 'blocks/Dropdown'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const DropdownLanguageSC = styled(Dropdown)<{
  position: 'top' | 'bottom'
  positionOffset: FIXED_INDENTS
}>`
  margin-top: auto;
  margin-left: auto;

  width: ${({ width }) => width || 'max-content'};

  ${DropdownBody} {
    /* Above sticky bottom ErrorMessage (z-index: 4); Footer must not create a stacking context */
    z-index: 5;
    bottom: ${({ position, positionOffset }) =>
      position === 'bottom' ? `var(${positionOffset})` : 'auto'};
    top: ${({ position, positionOffset }) =>
      position === 'top' ? `calc(100% + var(${positionOffset}))` : 'auto'};
  }

  ${ActionButtonSC} {
    padding: 0;
    min-width: 0;
    overflow: visible;
    background-color: var(${COLOR.TRANSPARENT});
    color: var(${COLOR.TEXT_ICON_SECONDARY});

    ${MEDIA.NO_TOUCH} {
      &:hover {
        background-color: var(${COLOR.TRANSPARENT});
        color: var(${COLOR.TEXT_ICON_SECONDARY});
      }
    }

    &:active {
      background-color: var(${COLOR.TRANSPARENT});
      color: var(${COLOR.TEXT_ICON_SECONDARY});
    }
  }

  ${IconSC} {
    width: var(${FIXED_INDENTS.INDENT_60});
    height: var(${FIXED_INDENTS.INDENT_60});
  }
`
